module.exports = "pegasus_template/assets/themecapture1/travel/102.png";